module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tooltip":"Leave"},"ja":{"tooltip":"離脱"},"zh-hant":{"tooltip":"脫離"},"zh-hans":{"tooltip":"脱离"}}')
  delete Component.options._Ctor
}
